<template>
  <div class="container">
    <!-- 标题 -->
    <p class="title">所属区域</p>
    <div class="separator"></div>
    <!-- 关闭 -->
    <div class="close-box" @click="onClose">
      <img src="../../../assets/common/arrow_down@2x.png"
              alt
              class="arrow-img" />
    </div>
    <!-- 选项 -->
    <div class="option-box">
      <!-- 一级选项 -->
      <div class="parent-box">
        <div class="parent-area-item" v-for="(area, index) in cityTreeList" :key="index" @click="onTapParentItem(index, area)">
          <p :class="selectedParent.txId == area.txId ? 'name selected':'name'">{{ area.shortName }}</p>
        </div>
      </div>
      <div class="separator-v"></div>
      <!-- 二级选项 -->
      <div class="children-box" v-if="childrenList.length > 0">
        <div class="children-area-item" v-for="(area, index) in childrenList" :key="index" @click="onTapChildItem(index, area)">
          <p :class="selectedChild.txId == area.txId ? 'name selected':'name'">{{ area.shortName }}</p>
          <van-icon v-if="selectedChild.txId == area.txId" name="success" color="#36b374" size="20"></van-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Col } from 'vant'

    export default {
        props: {
          cityTreeList: {
            type: Array,
            default: () => []
          },
          selectedArea: {
            type: Object,
            default: () => {}
          }
        },
        data () {
            return {
              childrenList: this.selectedArea.parent.children,
              selectedParent: this.selectedArea.parent,
              selectedChild: this.selectedArea.child
            }
        },
        methods: {
          onTapParentItem (index, area) {
            console.log('select parent area = ', area)
            this.selectedParent = area
            if (area.children.length > 0) {
              this.childrenList = area.children
            }
          },
          onTapChildItem (index, area) {
            this.selectedChild = area
            console.log('select child area = ', area)
            this.$emit('onConfirm', {parent: this.selectedParent, child: this.selectedChild})
          },
          onClose () {
            this.$emit('onClose')
          }
        },
        mounted () {
          console.log('city tree list = ', this.cityTreeList)
        }
    }
</script>

<style scoped lang="less">
@vv: 3.75vw;
.container {
  padding-top: 18/@vv;
  display: flex;
  flex-direction: column;
  .title {
    font-size: 16 /@vv;
    font-weight: 500;
    color: #171a1d;
    line-height: 22 /@vv;
    margin-bottom: 16/@vv;
    margin-left: 16/@vv;
    margin-top: 2/@vv;
  }
  .close-box {
    position: absolute;
    right: 16/@vv;
    top: 16/@vv;
    width: 20/@vv;
    height: 20/@vv;
    display: flex;
    justify-content: center;
    align-items: center;
    .arrow-img {
      width: 16/@vv;
      height: 16/@vv;
    }
  }
  .separator {
    height: 1px;
    background-color: #eeeeee;
    width: 100%;
  }
  .option-box {
    display: flex;
    height: 300/@vv;
    .parent-box {
      width: 100/@vv;
      padding-top: 8/@vv;
      overflow-y: scroll;
      .parent-area-item {
        height: 36/@vv;
        display: flex;
        align-items: center;
        .name {
          font-size: 14/@vv;
          color: #1e2226;
          font-weight: 400;
          margin-left: 16/@vv;
        }
        .selected {
          color: #36b374;
          font-weight: 500;
        }
      }
    }
    .separator-v {
      width: 1px;
      background-color: #eeeeee;
      height: 100%;
    }
    .children-box {
      width: 274/@vv;
      padding-top: 8/@vv;
      overflow-y: scroll;
      .children-area-item {
        height: 36/@vv;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 16/@vv;
        .name {
          font-size: 14/@vv;
          color: #1e2226;
          font-weight: 400;
          margin-left: 16/@vv;
        }
        .selected {
          color: #36b374;
          font-weight: 500;
        }
      }
    }
  }
  
}
</style>
